import React from 'react';
import DocContent from './DocContent';
import { blocks } from '../content/LPRecruitingContent';

export default function LPRecruiting() {
  return <DocContent blocks={blocks} />;
}
